// components/TechnologyManager.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";


const TechnologyManager = () => {
  const [technologies, setTechnologies] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchTechnologies();
  }, []);

  const fetchTechnologies = async () => {
    try {
      const res = await axios.get("https://modularobjects.com/checkout/api/technologies");
      setTechnologies(res.data);
    } catch (err) {
      console.error("Greška pri učitavanju:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`https://modularobjects.com/checkout/api/technologies/${editingId}`, { name, description });
      } else {
        await axios.post("https://modularobjects.com/checkout/api/technologies", { name, description });
      }
      setName("");
      setDescription("");
      setEditingId(null);
      fetchTechnologies();
    } catch (err) {
      console.error("Greška pri čuvanju:", err);
    }
  };

  const handleEdit = (tech) => {
    setEditingId(tech.id);
    setName(tech.name);
    setDescription(tech.description || "");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Da li ste sigurni da želite da obrišete tehnologiju?")) {
      try {
        await axios.delete(`https://modularobjects.com/checkout/api/technologies/${id}`);
        fetchTechnologies();
      } catch (err) {
        console.error("Greška pri brisanju:", err);
      }
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">Tehnologije</h2>

      <form onSubmit={handleSubmit} className="space-y-2 mb-4">
        <input
          type="text"
          placeholder="Naziv"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border px-2 py-1 rounded w-full"
          required
        />
        <textarea
          placeholder="Opis"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="border px-2 py-1 rounded w-full"
        ></textarea>
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          {editingId ? "Sačuvaj izmene" : "Dodaj"}
        </button>
      </form>

      <ul className="space-y-2">
        {technologies.map((tech) => (
          <li key={tech.id} className="bg-gray-100 p-2 rounded flex justify-between items-center">
            <div>
              <strong>{tech.name}</strong>
              {tech.description && <p className="text-sm text-gray-600">{tech.description}</p>}
            </div>
            <div className="space-x-2">
              <button onClick={() => handleEdit(tech)} className="text-blue-600">Izmeni</button>
              <button onClick={() => handleDelete(tech.id)} className="text-red-600">Obriši</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TechnologyManager;
